const cookie_domain = "uswhs.cosabella.com";
const path = "/";
const cookie_duration_in_days = 0;
$(document).ready(function(){
  var price_disable = Cookies.get("price-disable");
  if(price_disable){
    if(price_disable == "1"){
      $("#hide-pricing").addClass("inactive");
      $("#hide-pricing-mobile").addClass("inactive");
      if($("#show-pricing").hasClass("inactive")){$("#show-pricing").removeClass("inactive");}
       if($("#show-pricing-mobile").hasClass("inactive")){$("#show-pricing-mobile").removeClass("inactive");}
      $("body").addClass("disable-price");
    }else{
      $("#show-pricing").addClass("inactive");
      $("#show-pricing-mobile").addClass("inactive");
     if($("#hide-pricing").hasClass("inactive")){$("#hide-pricing").removeClass("inactive");}
       if($("#hide-pricing-mobile").hasClass("inactive")){$("#hide-pricing-mobile").removeClass("inactive");}
      if($("body").hasClass("disable-price")){$("body").removeClass("disable-price");}
    }
  }
  $("#hide-pricing").click(function(){
    Cookies.set("price-disable","1", {
            domain: cookie_domain,
            path : path
          });
    //location.reload(true);
     $("body").addClass("disable-price");
     $("#hide-pricing").addClass("inactive");
    $("#hide-pricing-mobile").addClass("inactive");
     if($("#show-pricing").hasClass("inactive")){$("#show-pricing").removeClass("inactive");}
    if($("#show-pricing-mobile").hasClass("inactive")){$("#show-pricing-mobile").removeClass("inactive");}
  });
  $("#hide-pricing-mobile").click(function(){
    Cookies.set("price-disable","1", {
            domain: cookie_domain,
            path : path
          });
    //location.reload(true);
     $("body").addClass("disable-price");
     $("#hide-pricing").addClass("inactive");
    $("#hide-pricing-mobile").addClass("inactive");
     if($("#show-pricing").hasClass("inactive")){$("#show-pricing").removeClass("inactive");}
     if($("#show-pricing-mobile").hasClass("inactive")){$("#show-pricing-mobile").removeClass("inactive");}
  });
  $("#show-pricing").click(function(){
    Cookies.set("price-disable","0", {
            domain: cookie_domain,
            path : path
          });
     $("#show-pricing").addClass("inactive");
    $("#show-pricing-mobile").addClass("inactive");
     if($("#hide-pricing").hasClass("inactive")){$("#hide-pricing").removeClass("inactive");}
    if($("#hide-pricing-mobile").hasClass("inactive")){$("#hide-pricing-mobile").removeClass("inactive");}
    if($("body").hasClass("disable-price")){$("body").removeClass("disable-price");}
  });
  $("#show-pricing-mobile").click(function(){
    Cookies.set("price-disable","0", {
            domain: cookie_domain,
           path : path
          });
    $("#show-pricing").addClass("inactive");
    $("#show-pricing-mobile").addClass("inactive");
    if($("#hide-pricing").hasClass("inactive")){$("#hide-pricing").removeClass("inactive");}
    if($("#hide-pricing-mobile").hasClass("inactive")){$("#hide-pricing-mobile").removeClass("inactive");}
    if($("body").hasClass("disable-price")){$("body").removeClass("disable-price");}
  });
});